"use client";

import React from "react";
import { Clock, Shield, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Bespaar geld",
  description: "Bespaar tot 40% op uw project door eenvoudig verschillende offertes van lokale specialisten te vergelijken.",
  icon: CircleCheck
}, {
  title: "Bespaar tijd",
  description: "Het invullen van uw aanvraag duurt slechts 1 minuut. Wij regelen de rest voor u en u ontvangt snel reactie.",
  icon: Clock
}, {
  title: "Meerdere offertes",
  description: "U ontvangt voorstellen van betrouwbare en gecertificeerde asbest specialisten uit uw eigen regio.",
  icon: Shield
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="124770" id="waarom-asbest-offertesbe" className="bg-white py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1AAD4A]/5 rounded-full blur-3xl pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="text-[26px] md:text-3xl font-serif font-bold text-[#182329] tracking-tight mb-4">Waarom AsbestOfferteFormulier.be?</h2>
          <p className="text-[#627881] font-sans max-w-2xl mx-auto text-[18px]">
            Vind dé vakspecialist voor uw project en bespaar direct op uw kosten door offertes van verschillende specialisten te vergelijken.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-white/40 backdrop-blur-sm border-[#DCDFE0] rounded-sm hover:border-[#1AAD4A]/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-sm group">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-sm bg-[#1AAD4A]/10 group-hover:bg-[#1AAD4A]/20 transition-colors duration-300">
                      <Icon className="h-6 w-6 text-[#1AAD4A] drop-shadow-[0_0_8px_rgba(26,173,74,0.3)]" />
                    </div>
                    <CardTitle className="text-[18px] font-sans font-bold text-[#182329]">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-[#182329] font-sans text-[18px] leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}